export const generateTimeSlots = (
  startTime = '10:00',
  endTime = '18:00',
  interval = 15,
) => {
  const optionsHours = [];
  let [hours, minutes] = startTime.split(':').map(Number);
  const [endHours, endMinutes] = endTime.split(':').map(Number);

  while (hours < endHours || (hours === endHours && minutes < endMinutes)) {
    const start = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
    minutes += interval;
    if (minutes >= 60) {
      hours += 1;
      minutes %= 60;
    }
    const end = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
    optionsHours.push(`${start} - ${end}`);
  }

  return optionsHours;
};
